<template>
  <div class="outline_deal">
    <tableHeader
      :chekTableNum="chekTableNum"
      @allCheck="toggleSelection(tableData,'true')"
      @cancelAllCheck="toggleSelection([])"
    ></tableHeader>
    <el-table
      :data="tableData"
      header-row-class-name="no-header"
      @selection-change="toggleSelection"
      ref="multipleTable"
      @row-click="rowClick"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index"></el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <delReportInfo :info="scope.row" :reportTime="false"></delReportInfo>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div>处理时间:{{scope.row.updatetime | fullTime}}</div>
          <div>处理结果:{{scope.row.result}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 右侧详情页 -->
    <rightInfo ref="rightInfo" @loadPage="loadPage"></rightInfo>
  </div>
</template>
<script>
import tableHeader from "views/CreditScore/common/tableHeader"; //勾选全部
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import rightInfo from "./rightInfo";
import delReportInfo from "../common/delReportInfo";

export default {
  components: { tableHeader, rightInfo, delReportInfo },
  props: {
    tableData: {
      type: Array,
      required: true
    },
    tableIndex: {
      type: Number,
      required: true
    },
    all: {
      type: Number
    }
  },
  data() {
    return {
      chekTableNum: {
        all: this.all,
        check: 0,
        date: this.tableData[0].checkTitle,
        sortName: this.tableData[0].sortName,
      }
    };
  },
  computed: {
    ...mapState({
      deductMarks: state => state.creditScore.deductMarks
    })
  },
  watch: {
    all: {
      handler: function(val, oldval) {
        this.chekTableNum.all =val
      }
    }
  },
  methods: {
    ...mapMutations(["saveCheckId"]),
    ...mapActions(["getById"]),
    loadPage() {
      this.$emit("loadPage");
    },
    toggleSelection(rows) {
      if (rows.length > 0) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.$set(this.chekTableNum, "check", rows.length);
      this.setCheckMarks(rows);
    },
    setCheckMarks(row) {
      let deductMarks = this.deductMarks;
      deductMarks[this.tableIndex] = row;
      this.saveCheckId(deductMarks);
    },
    async rowClick(row) {
      await this.getById(row.reportid);
      this.$refs.rightInfo.rightInfoSync = true;
    }
  }
};
</script>
<style lang="scss">
.outline_deal {
  .no_margin {
    margin: 0 0 20px 0;
  }
}
</style>
